import { useLang } from "../i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee.items");

  const row = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center pe-16 md:pe-24">
      {items.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display whitespace-nowrap text-sm tracking-[0.35em] text-gold/90 md:text-base">{w}</span>
          <span className="mx-8 h-1.5 w-1.5 rotate-45 bg-gold/50 md:mx-12" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden border-y border-gold/15 bg-wine/60 py-5" data-testid="marquee">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
